import { buildQuery } from '../../../utils/query';

// The workflow API (assets-api: dashboard/inbox/, dashboard/requests/). A
// request is addressed by a typed id -- TR-<uuid> transfer, DP-<uuid> disposal,
// RP-<uuid> maintenance, RG-<uuid> stock-take regularization -- built with
// requestKey() below from the record a screen already holds.
export default {
  INBOX: ({ page = 1, rowsPerPage = 10, scope, bucket, type, status, searchTerm } = {}) =>
    `dashboard/inbox/${buildQuery({
      page,
      page_size: rowsPerPage,
      scope,
      bucket,
      type,
      status,
      search_term: searchTerm,
    })}`,
  REQUEST: (key) => `dashboard/requests/${key}/`,
  DECIDE: (key) => `dashboard/requests/${key}/decisions/`,
};

const PREFIXES = { transfer: 'TR', disposal: 'DP', repair: 'RP', regularization: 'RG' };

/** `requestKey('transfer', transfer.id)` -> `TR-<uuid>`. */
export const requestKey = (type, id) => `${PREFIXES[type]}-${id}`;
